/**
 * Costanti fiscali italiane condivise (tenant + master).
 *
 * Estratte da `CompanyFormModal` tenant per riuso nel modale master
 * ragioni sociali: regimi fiscali RF (FatturaPA) e sigle provincia
 * per l'ufficio REA.
 */
export const TAX_REGIMES: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'RF01', label: 'RF01 — Ordinario' },
  { value: 'RF02', label: 'RF02 — Contribuenti minimi' },
  { value: 'RF04', label: 'RF04 — Agricoltura e attività connesse' },
  { value: 'RF05', label: 'RF05 — Vendita sali e tabacchi' },
  { value: 'RF06', label: 'RF06 — Commercio fiammiferi' },
  { value: 'RF07', label: 'RF07 — Editoria' },
  { value: 'RF08', label: 'RF08 — Gestione servizi telefonia pubblica' },
  { value: 'RF09', label: 'RF09 — Rivendita documenti di trasporto' },
  { value: 'RF10', label: 'RF10 — Intrattenimenti, giochi' },
  { value: 'RF11', label: 'RF11 — Agenzie viaggi e turismo' },
  { value: 'RF12', label: 'RF12 — Agriturismo' },
  { value: 'RF13', label: 'RF13 — Vendite a domicilio' },
  { value: 'RF14', label: 'RF14 — Rivendita beni usati, oggetti d\'arte' },
  { value: 'RF15', label: 'RF15 — Vendite all\'asta oggetti d\'arte' },
  { value: 'RF16', label: 'RF16 — IVA per cassa P.A.' },
  { value: 'RF17', label: 'RF17 — IVA per cassa' },
  { value: 'RF18', label: 'RF18 — Altro' },
  { value: 'RF19', label: 'RF19 — Forfettario' },
];

export const PROVINCE_REA: ReadonlyArray<string> = [
  'AG','AL','AN','AO','AR','AP','AT','AV','BA','BT','BL','BN','BG','BI','BO','BZ','BS','BR','CA','CL','CB','CE','CT','CZ','CH','CO','CS','CR','KR','CN','EN','FM','FE','FI','FG','FC','FR','GE','GO','GR','IM','IS','SP','AQ','LT','LE','LC','LI','LO','LU','MC','MN','MS','MT','ME','MI','MO','MB','NA','NO','NU','OR','PD','PA','PR','PV','PG','PU','PE','PC','PI','PT','PN','PZ','PO','RG','RA','RC','RE','RI','RN','RM','RO','SA','SS','SV','SI','SR','SO','SU','TA','TE','TR','TO','TP','TN','TV','TS','UD','VA','VE','VB','VC','VR','VV','VI','VT',
];
